
import axios from '../axios/axios';
import Cookies from 'js-cookie'; 
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function ValiderInscription() { 
    const navigate = useNavigate();
  const { code } = useParams();

    const setAuthToken = (token) => {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    };

    useEffect(() => {
        valider();    
    }, []);



    const valider = () => {
      axios.get(`/validerInscription/${code}`,{
          headers: {
          Accept: "application/json", 
          },
      })
      .then((response) => {
            const { access_token } = response.data;
            const { user } = response.data;
            setAuthToken(access_token);
            Cookies.set('auth_token', access_token);
            Cookies.set('auth_user', JSON.stringify(user));
           navigate(`${process.env.PUBLIC_URL}/profile`) 
      }).catch((err) => {
          console.log(err);
      });

  }

  return (
           <div className="container mt-5">
                <div className="row bg-light">
                    <div className="col-sm-12">
                        <center>
                            <h3 style={{fontWeight: '900', padding: '10px'}}>
                                Validation encoure ...

                            </h3>
                        </center>
                    </div>
                </div>
            </div>
  )
}
